import clsx from 'clsx'

function SkeletonBlock({ className }: { className?: string }) {
  return <div className={clsx('animate-pulse rounded-control bg-surface-raised', className)} />
}

// Skeleton shapes matching the 4-card + activity-list layout - no spinner
// for a page-level load, per FIGMA_AI_PROMPT.md's loading-state rule.
export function DashboardSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      <div className="grid grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, index) => (
          <SkeletonBlock key={index} className="h-24" />
        ))}
      </div>
      <SkeletonBlock className="h-48" />
    </div>
  )
}
